import { Component, Input, OnInit } from '@angular/core'
import { CMSService } from 'src/app/services/cms.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzModalRef } from 'ng-zorro-antd/modal'
import { DropPointForm } from 'src/app/services/interface/drop-point.model'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'

@Component({
  selector: 'app-view-drop-point',
  templateUrl: './view-drop-point.component.html',
})
export class ViewDropPointComponent implements OnInit {
  isLoading: boolean = true
  constructor(
    private fb: FormBuilder,
    private cmsService: CMSService,
    private notification: NzNotificationService,
    private msg: NzMessageService,
    private modal: NzModalRef,
  ) {
    this.form = this.fb.group({
      city: [null, Validators.compose([Validators.required])],
      locationName: [null, Validators.compose([Validators.required])],
      locationSide: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      phoneNumber: [null],
      mapLinks: [null],
      radiusSite: [null],
      latitude: [null],
      longitude: [null],
    })
  }

  @Input() locationId: string
  form: FormGroup
  ngOnInit(): void {
    this.fetchDropPointDetails()
    this.form.statusChanges.subscribe(state => {
      this.modal.updateConfig({ nzOkDisabled: state === 'INVALID' })
    })
  }

  fetchDropPointDetails() {
    this.isLoading = true
    this.cmsService.dropPointDetail(this.locationId).subscribe(res => {
      this.form.patchValue(res)
      this.isLoading = !this.isLoading
    })
  }

  submitForm(): boolean {
    this.isLoading = true
    this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })

    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    if (this.form.valid) {
      var formSubs: DropPointForm = this.form.value
      formSubs.locationId = this.locationId
      this.cmsService.updateDropPoint(formSubs).subscribe(
        r => {
          this.notification.success('Success', r.message)
          this.isLoading = false
          this.modal.destroy()
          this.fetchDropPointDetails()
          return true
        },
        err => {
          this.notification.error('Error', err.error.message)
          this.isLoading = false
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          this.fetchDropPointDetails()
          return false
        },
      )
    } else {
      this.msg.error('Please Fill Blank Form')
      this.isLoading = false
      this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
      this.fetchDropPointDetails()
      return false
    }
  }
}
